import { render, staticRenderFns } from "./aiRecord.vue?vue&type=template&id=9729583a&scoped=true&"
import script from "./aiRecord.vue?vue&type=script&lang=js&"
export * from "./aiRecord.vue?vue&type=script&lang=js&"
import style0 from "./aiRecord.vue?vue&type=style&index=0&id=9729583a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9729583a",
  null
  
)

export default component.exports